/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    export class MeevoFullAddress implements angular.IDirective {
        restrict = "E";
        scope = {
            disabled: "=ngDisabled",
            addressData: "=",
            isReadonly: "=",
            hideCountry: "=?",
            required: "=ngRequired",
            change: "&?",
            useFirstZipResult: "=?",
            tabIndexDataSource: "&"
        };
        private isModalOpen: boolean = false;

        templateUrl = "app/components/controls/fullAddressTemplate.html";

        constructor(
            private appSettings: Meevo.Components.Common.IAppSettings,
            private postalCodeService: Meevo.Components.Common.IPostalCodeService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,
            private $timeout: angular.ITimeoutService
        ) {

        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            scope.tabIndexData = scope.tabIndexDataSource() || { address1: null, address2: null, city: null, state: null, zip: null, country: null };

            scope.states = [];
            scope.usaStates = [];
            scope.canProvinces = [];
            scope.ukCounties = [];

            let original = angular.copy(scope.addressData)

            scope.onPostalCodeChange = (postalCodeData: any): void => {
                scope.addressData.city = postalCodeData.city;
                scope.addressData.state = postalCodeData.state;
            };
            let defaults = { country: this.appSettings.APP_COUNTRYID.substr(3).toUpperCase(), city: null, zipCode: null };
            scope.addressData = _.defaults(scope.addressData, defaults) || defaults;

            /*  TODO:   Remove When Server/DB Implements CountryEnum    */
            scope.addressData.country = scope.addressData.country === 'USA' ? 'US' : scope.addressData.country;

            scope.$watch(() => {
                if (Model.Guard.isNothing(scope.addressData)) {
                    return null;
                }
                if (Model.Guard.isNothing(scope.addressData.country)) {
                    scope.addressData.country = this.appSettings.APP_COUNTRYID.substr(3).toUpperCase();
                }

                return scope.addressData.country;
            },
                (newVal, oldVal) => {
                    scope.states = [];
                    scope.addressData = (!angular.equals(scope.addressData, original) && oldVal && newVal !== oldVal && original && original.country && original.country.trim().toLowerCase() !== 'other') ?
                        _.extend(scope.addressData, { state: null, city: null, zipCode: null }) :
                        scope.addressData  
                    /*  TODO:   Since locale en-gb is linked to 'UnitedKingdom' Change To CountryEnum When Server/DB Implements CountryEnum
                    *           Changed to scope.request.country so scope.postalCodeCheck() use same country
                    */
                    let country = newVal;
                    scope.request = {
                        country: country
                    };

                    switch (newVal) {
                        case 'CA':
                            scope.zipLength = 6;
                            if (scope.canProvinces.length === 0 && newVal) {
                                this.postalCodeService.getStates(scope.request)
                                    .then((result: any) => {
                                        scope.canProvinces = result.data;
                                        scope.canProvinces.unshift({ state: '' });
                                        scope.states = _.clone(scope.canProvinces);
                                        return result;
                                    });
                            } else {
                                scope.states = _.clone(scope.canProvinces);
                            }
                            break;
                        case 'UK':
                        case 'GB':
                            scope.zipLength = 6;                    /*  TEST : FK21 8SY */
                            scope.request.country = 'UK';           /*  Needed Since Server/DB Does Not Implements CountryEnum*/
                            if (scope.ukCounties.length === 0 && newVal) {
                                this.postalCodeService.getStates(scope.request)
                                    .then((result: any) => {
                                        scope.ukCounties = result.data;
                                        scope.ukCounties.unshift({ state: '' });
                                        scope.states = _.clone(scope.ukCounties);
                                        return result;
                                    });
                            } else {
                                scope.states = _.clone(scope.ukCounties);
                            }
                            break;
                        case 'US':
                            scope.zipLength = 5;
                            if (scope.usaStates.length === 0 && newVal) {
                                this.postalCodeService.getStates(scope.request)
                                    .then((result: any) => {
                                        scope.usaStates = result.data;
                                        //scope.usaStates.unshift({ state: '' });   // Default Country 'US' All states are known
                                        scope.states = _.clone(scope.usaStates);
                                        return result;
                                    });
                            } else {
                                scope.states = _.clone(scope.usaStates);
                            }
                            break;
                        default:                            /*  TODO: Define Defaults In app.settings   */
                            scope.zipLength = 20;
                            scope.stateLength = 25;
                            scope.cityLength = 50;
                            break;
                    }

                    let countryId = country || this.appSettings.APP_COUNTRYID.substr(3).toUpperCase();
 
                    // Handling Address Block Labels and Formats
                    let countryInfo = this.appSettings.APP_COUNTRIES[countryId];
                    if (!countryInfo && country.length > 0) { /* this will be null when user does not have permission to see address info */
                        countryInfo = this.appSettings.APP_COUNTRIES[this.appSettings.APP_COUNTRYID.substr(3).toUpperCase()];
                    }
                    if (countryInfo) {
                        scope.shows = countryInfo['AddressBlockShows'].split('|');
                        scope.labels = countryInfo['AddressBlockLabels'].split('|');
                    }

                    if (scope.addressData) {
                        scope.postalCodeCheck();
                    }
                });

            scope.postalCodeCheck = (state = false): void => {
                var doLookup = false;
                if (angular.isFunction(scope.change)) {
                    scope.change();
                }

                if (Model.Guard.isNothing(scope.addressData)) {
                    doLookup = true;
                } 
                else {
                    // Either populate zipcode from city/state or populate city/state from zipcode.
                    doLookup = (_.isEmpty(scope.addressData.city)
                                && scope.addressData.zipCode
                                && scope.addressData.zipCode.length >= scope.zipLength
                                && scope.addressData.country !==  'OTHER')                                      // Check --> Meevo.Model.CountryEnum.Other)
                                || (_.isEmpty(scope.addressData.zipCode) && !_.isEmpty(scope.addressData.city));
                }

                if (state && !doLookup) { //Updating the zipcode based on the state change
                    var zipRequest = {
                        postalCode: '',
                        city: scope.addressData.city,
                        state: scope.addressData.state,
                        country: scope.request.country      //scope.addressData.country
                    }
                    this.postalCodeService.lookupPostalCode(zipRequest)
                        .then((response: any) => {
                            if (Model.Guard.isSomething(response[0]))
                                scope.addressData.zipCode = response[0].postalCode;
                            else {
                                scope.addressData.zipCode = ''
                            }
                            
                        })
                }

                if (doLookup) {
                    var request = {
                        postalCode: Model.Guard.isSomething(scope.addressData.zipCode) ? scope.addressData.zipCode.replace(' ', '') : '',
                        city: scope.addressData.city,
                        state: scope.addressData.state,
                        country: scope.request.country      //scope.addressData.country
                    }

                    this.postalCodeService.lookupPostalCode(request)
                        .then((response: any) => {
                            if (_.isEmpty(scope.addressData.zipCode)) {
                                if (Model.Guard.isSomething(response[0]))
                                    scope.addressData.zipCode = response[0].postalCode;
                            }

                            else {
                                if (response.length === 1) {
                                    scope.addressData.city = response[0].city;
                                    scope.addressData.state = response[0].state;
                                    // If user entered non-US post code without spaces, populate with the valid one.
                                    if (response[0].postalCode.indexOf(' ') >= 0) {
                                        scope.addressData.zipCode = response[0].postalCode;
                                    }

                                } else {
                                    if (response.length > 1) {
                                        if (scope.useFirstZipResult) {
                                            scope.addressData.city = response[0].city;
                                            scope.addressData.state = response[0].state;
                                        } else if (!scope.disabled) {
                                            let options: Meevo.Components.Modal.IModalOptions = {
                                                templateUrl: "app/components/controls/postalCodeResults.html",
                                                controller: "meevo.components.controls.PostalCodeResultsController",
                                                controllerAs: "vm",
                                                bindToController: true,
                                                locals: {
                                                    choices: response
                                                }
                                            }
                                            if (!this.isModalOpen) {
                                                this.isModalOpen = true;
                                                this.modalService.showCustom(options, null, true)
                                                    .then((selection: any) => {
                                                        if (selection) {
                                                            scope.addressData.city = selection.city;
                                                            scope.addressData.state = selection.state;
                                                        }
                                                        return selection;
                                                    }).finally(() => {
                                                        this.isModalOpen = false;
                                                    });
                                            }
                                        }
                                    }
                                }
                            }
                            return response;
                        });
                }
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (
                appSettings: Meevo.Components.Common.IAppSettings,
                postalCodeService: Meevo.Components.Common.IPostalCodeService,
                modalService: Meevo.Components.Modal.IModalService,
                $translate: angular.translate.ITranslateService,
                $timeout: angular.ITimeoutService) => {
                return new MeevoFullAddress(appSettings, postalCodeService, modalService, $translate, $timeout);
            };

            directive.$inject = ["meevo.AppSettings", "meevo.components.common.PostalCodeService", "meevo.components.modal.ModalService", "$translate", "$timeout"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoFullAddress", MeevoFullAddress.factory());
}